import React from "react";
import styles from "./LoginStatus.module.css";
import { useNavigate } from "react-router";
import { path, subPaths } from "../common/Common";

import { useModal } from "../modal/Modal";
import ModalButtons from "../modal/ModalButtons";

interface LoginStatusProps {
    member?: string;
    logout: (...args: any) => any;
}

/**
 * @author mj
 * @date 2022-08-24 13:07:03
 * @remark 로그인(로그인 후)
 * @param props LoginStatusProps
 * @props username(required) : 유저명
 *        logout(required) : 로그아웃 버튼 눌렀을 때 실행 콜백
 *        mypage(required) : 마이페이지 버튼 눌렀을 때 실행 콜백
 */
function LoginStatus(props: LoginStatusProps) {
    const { ModalComponent, openModal, closeModal } = useModal();

    const navigate = useNavigate();

    const goToMyPage = () => {
        navigate([path.MYPAGE, subPaths.MYPAGE[0]].join("/"));
    };

    const clickedLogout = () => {
        openModal({
            title: "안내",
            children: "로그아웃 하시겠습니까?",
            modalButtons: (
                <ModalButtons
                    buttonCount={2}
                    buttons={[
                        {
                            label: "취소",
                            color: "Secondary",
                            onClick: () => {
                                closeModal();
                            },
                        },
                        {
                            label: "확인",
                            color: "Primary",
                            onClick: () => {
                                props.logout();
                                closeModal();
                            },
                        },
                    ]}
                />
            ),
        });
    };

    return (
        <>
            <ModalComponent />
            <div className={styles.btn_bx}>
                <div className={styles.username}>{props.member} 님</div>
                <button className={styles.btn} onClick={goToMyPage}>
                    마이페이지
                </button>
                <button className={styles.btn} onClick={clickedLogout}>
                    로그아웃
                </button>
            </div>
        </>
    );
}

export default LoginStatus;
